import { useContext, useEffect, useRef, useState } from "react";
import Select from 'react-select';
import { arrow_right, chooseDocumentIcon, closeIcon } from "../../../assets/icons";
import styles from "./newAdPartTwo.module.css";
import { fetchFilters } from "../../../Api/Services/Alternative";
import AdditionalDocuments from "../AdditionalDocuments/AdditionalDocuments";
import { WizardContext } from "../../../Store/Wizard.store";
import InfoPopup from "../../InfoPopup";
interface NewAdPartOneProps {
  backButton: (buttonText: string) => JSX.Element;
}

export default function NewAdPartTwo({ backButton }: NewAdPartOneProps) {
  const { wizardFormData, setWizardFormData } = useContext(WizardContext);
  const [technicalDocumentText, setTechnicalDocumentText] = useState("Upload Tecnical Data Sheet");
  const [safetydataText, setsafetydataText] = useState("Upload Safety Data Sheet");
  const [uploadedFiles, setUploadedFiles] = useState<string[]>(wizardFormData.editMode == true && wizardFormData.adData.additionalDocuments && wizardFormData.adData.additionalDocuments.length > 0 ? wizardFormData.adData.additionalDocuments?.map((file) => { return file.fileName }) : []);
  const [alternativeToOptions, setAlternativeToOptions] = useState<{ value: number, label: string }[]>([]);
  const [useOptions, setUseOptions] = useState<{ value: number, label: string }[]>([]);
  const [useSectorOptions, setUseSectorOptions] = useState<{ value: number, label: string }[]>([]);
  const [thirdPartyOptions, setThirdPartyOptions] = useState<{ value: number, label: string }[]>([]);
  const [disableTechnical, setDisableTechnical] = useState(wizardFormData.editMode == true && wizardFormData.adData.technicalDataSheet != undefined && wizardFormData.adData.technicalDataSheet?.fileName != "" ? true : false);
  const [disableSafety, setDisableSafety] = useState(wizardFormData.editMode == true && wizardFormData.adData.safetyDataSheet != undefined && wizardFormData.adData.safetyDataSheet?.fileName != "" ? true : false);
  const technicalDocumentRef = useRef<HTMLInputElement>(null);
  const safetydataRef = useRef<HTMLInputElement>(null);
  const biBasedYesRef = useRef<HTMLInputElement>(null);
  const biBasedNoRef = useRef<HTMLInputElement>(null);
  const h2Ref = useRef<HTMLHeadingElement>(null);
  const titleRef = useRef<HTMLInputElement>(null);
  const aboutRef = useRef<any>(null);
  const AlternativeToRef = useRef<any>(null);
  const useCatRef = useRef<any>(null);
  const sectorRef = useRef<any>(null);
  const certificationRef = useRef<any>(null);

  useEffect(() => {
    getFilters();
    if (h2Ref.current) {
      h2Ref.current.scrollIntoView();
    }
    // Truncate title if it's longer than 80 characters (for edit mode)
    if (wizardFormData.adData.title.length > 80) {
      setWizardFormData({ 
        ...wizardFormData, 
        adData: { 
          ...wizardFormData.adData, 
          title: wizardFormData.adData.title.slice(0, 80) 
        } 
      });
    }
  }, []);

  useEffect(() => {
    if (wizardFormData.adData.technicalDataSheet && wizardFormData.adData.technicalDataSheet?.fileName != "") {
      setDisableTechnical(true);
    } else {
      setDisableTechnical(false);
    }
  }, [wizardFormData.adData.technicalDataSheet]);

  useEffect(() => {
    if (wizardFormData.adData.safetyDataSheet && wizardFormData.adData.safetyDataSheet?.fileName != "") {
      setDisableSafety(true);
    } else {
      setDisableSafety(false);
    }
  }, [wizardFormData.adData.safetyDataSheet]);

  const getFilters = () => {
    fetchFilters().then((data) => {
      let options: { value: number, label: string }[] = [];
      data.alternativeToCategories?.map((category) => {
        options.push({ value: category.id, label: category.name });
      });
      setAlternativeToOptions(options);
      options = [];
      data.useCategories?.map((category) => {
        options.push({ value: category.id, label: category.name });
      });
      setUseOptions(options);
      options = [];
      data.sectorCategories?.map((category) => {
        options.push({ value: category.id, label: category.name });
      });
      setUseSectorOptions(options);
      options = [];
      data.certificationsCategories?.map((category) => {
        options.push({ value: category.id, label: category.name });
      });
      setThirdPartyOptions(options);
      setWizardFormData({ ...wizardFormData, alternativeFilter: data.alternativeLevels })
    });
  };

  const handleFileUpload = (fileName: string) => {
    setUploadedFiles([...uploadedFiles, fileName]);
  };

  const updateTechnicalDocumentText = () => {
    if (technicalDocumentRef.current?.files && technicalDocumentRef.current.files.length > 0) {
      setTechnicalDocumentText(technicalDocumentRef.current.files[0].name);
      setWizardFormData({
        ...wizardFormData,
        adData: {
          ...wizardFormData.adData,
          technicalDataSheet: {
            fileData: technicalDocumentRef.current.files[0],
            fileName: technicalDocumentRef.current.files[0].name,
            id: 0,
            mimeType: '',
          }
        },
      });
    } else {
      setTechnicalDocumentText("Upload Tecnical Data Sheet");
      setWizardFormData({
        ...wizardFormData,
        adData: {
          ...wizardFormData.adData,
          technicalDataSheet: {
            fileData: new File([""], ""),
            fileName: '',
            id: 0,
            mimeType: '',
          }
        },
      });
    }
  };
  const updateSafetydataText = () => {
    if (safetydataRef.current?.files && safetydataRef.current.files.length > 0) {
      setsafetydataText(safetydataRef.current.files[0].name);
      setWizardFormData({
        ...wizardFormData,
        adData: {
          ...wizardFormData.adData,
          safetyDataSheet: {
            fileData: safetydataRef.current.files[0],
            fileName: safetydataRef.current.files[0].name,
            id: 0,
            mimeType: '',
          }
        },
      });
    } else {
      setsafetydataText("Upload Safety Data Sheet");
      setWizardFormData({
        ...wizardFormData,
        adData: {
          ...wizardFormData.adData,
          safetyDataSheet: {
            fileData: new File([""], ""),
            fileName: '',
            id: 0,
            mimeType: '',
          }
        },
      });
    }
  };

  const nextStep = () => {
    if (wizardFormData.adData.title.trim() == "" || wizardFormData.adData.title.length > 80) {
      titleRef.current?.classList.add("error");
    }
    if (wizardFormData.adData.description.trim() == "") {
      aboutRef.current?.classList.add("error");
    }
    if (wizardFormData.adData.alternativeToCategories.length == 0) {
      AlternativeToRef.current?.inputRef?.classList.add("error");
    }
    if (wizardFormData.adData.useCategories.length == 0) {
      useCatRef.current?.inputRef?.classList.add("error");
    }
    if (wizardFormData.adData.sectorCategories.length == 0) {
      sectorRef.current?.inputRef?.classList.add("error");
    }

    // Focus the first element with the class "error"
    const firstErrorElement = document.querySelector(".error");
    if (firstErrorElement) {
      (firstErrorElement as HTMLElement).focus();
    } else {
      setWizardFormData({ ...wizardFormData, wizardStep: 3 });
    }
  };

  const updatedMultiSelect = (choice: any, key: string) => {
    const selectedValues = choice.map((item: { value: number, label: string, hits: number }) => ({ id: item.value, name: item.label, isSelected: false, hits: 0 }));
    switch (key) {
      case 'use':
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, useCategories: selectedValues } });
        useCatRef.current?.inputRef?.classList.remove("error");
        break;
      case 'useSector':
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, sectorCategories: selectedValues } });
        sectorRef.current?.inputRef?.classList.remove("error");
        break;
      case 'certification':
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, certificationCategories: selectedValues } });
        certificationRef.current?.inputRef?.classList.remove("error");
        break;
      case 'alternativeTo':
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, alternativeToCategories: selectedValues } });
        AlternativeToRef.current?.inputRef?.classList.remove("error");
        break;
      default:
        break;
    }
  };

  const removeExistingFile = (fileName: string, fileType: string) => {
    switch (fileType) {
      case "technical":
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, technicalDataSheet: undefined } });
        break;
      case "safety":
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, safetyDataSheet: undefined } });
        break;
      case "additional":
        setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, additionalDocuments: wizardFormData.adData.additionalDocuments?.filter((file) => file.fileName != fileName) } });
        setUploadedFiles(uploadedFiles.filter((file) => file != fileName));
        break;
      default:
        break;
    }
  };
  return (
    <div>
      {backButton("Contact information")}
      <h2 ref={h2Ref}>Create your ad</h2>
      <div className={styles.content}>        <div className={styles.input_container}>
        <label htmlFor="title">Title of your ad *</label>
        <InfoPopup content="This is the first impression potential customers will get from your product. Choose a descriptive title so people quickly can assess what you are offering. Around 50 characters are good. Maximum 80 characters." />
        <span>(Maximum 80 characters)</span>
        <input
          ref={titleRef}
          type="text"
          name="title"
          id="title"
          placeholder="Title of your ad"
          required
          maxLength={80}
          value={wizardFormData.adData.title}
          onChange={(e) => {
            const newValue = e.target.value.slice(0, 80);
            setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, title: newValue } });
          }}
          onBlur={(e) => (e.target.value.trim() == "" || e.target.value.length > 80) ? e.target.classList.add("error") : e.target.classList.remove("error")}
        />
      </div>
        <div className={styles.input_container}>
          <label htmlFor="about">About your alternative *</label>
          <InfoPopup content="This should be brief and provide short information of the solution or product and how it can be used. Maximum 500 characters." />
          <textarea
            ref={aboutRef}
            rows={10}
            name="about"
            id="about"
            placeholder="About your alternative"
            required
            value={wizardFormData.adData.description}
            onChange={(e) => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, description: e.target.value } })}
            onBlur={(e) => e.target.value.trim() == "" ? e.target.classList.add("error") : e.target.classList.remove("error")}
          />
        </div>
        <div className={styles.input_container}>
          <label htmlFor="alternativeTo">Alternative to *</label>
          <InfoPopup content="The specific hazardous substance or substance group that your alternative can replace." />
          <Select
            ref={AlternativeToRef}
            isMulti
            name="alternativeTo"
            id="alternativeTo"
            options={alternativeToOptions}
            defaultValue={wizardFormData.adData.alternativeToCategories.map((category) => ({ value: category.id, label: category.name }))}
            className="multi_select"
            classNamePrefix="select"
            placeholder="What can your alternative replace?"
            onChange={(choice) => updatedMultiSelect(choice, 'alternativeTo')}
          />
        </div>        
        <div>
          <div className={styles.input_container}>            
            <label htmlFor="use">Use *</label>
            <InfoPopup content="The specific function(s) of your alternative." />
            <Select
              ref={useCatRef}
              isMulti
              name="use"
              id="use"
              options={useOptions}
              defaultValue={wizardFormData.adData.useCategories.map((category) => ({ value: category.id, label: category.name }))}
              className="multi_select"
              classNamePrefix="select"
              placeholder="Choose how you can use this alternative"
              onChange={(choice) => updatedMultiSelect(choice, 'use')}
            />
          </div>
          <div className={styles.input_container}>            
            <label htmlFor="useSector">Sector of use *</label>
            <InfoPopup content="In which product segments can your alternative be used." />
            <Select
              ref={sectorRef}
              isMulti
              name="useSector"
              id="useSector"
              options={useSectorOptions}
              defaultValue={wizardFormData.adData.sectorCategories.map((category) => ({ value: category.id, label: category.name }))}
              className="multi_select"
              classNamePrefix="select"
              placeholder="Choose a sector of use"
              onChange={(choice) => updatedMultiSelect(choice, 'useSector')}
            />
          </div>
        </div>
        <div>
          <div className={styles.input_container}>
            <label htmlFor="certification">Third party labels and certifications</label>
            <InfoPopup content="You may be asked to produce documentation to verify this information." />
            <Select
              ref={certificationRef}
              isMulti
              name="certification"
              id="certification"
              options={thirdPartyOptions}
              defaultValue={wizardFormData.adData.certificationCategories.map((category) => ({ value: category.id, label: category.name }))}
              className="multi_select"
              classNamePrefix="select"
              placeholder="Choose third party labels and certifications"
              onChange={(choice) => updatedMultiSelect(choice, 'certification')}
            />
          </div>
          <div className={`${styles.input_container} ${styles.checkboxes}`}>
            <span>
              <b>Is your solution bio-based?</b>
            </span>
            <div>
              <input
                ref={biBasedYesRef}
                type="radio"
                name="bioBased"
                id="bioBased-yes"
                value="true"
                checked={wizardFormData.adData.isBioBased == true}
                onChange={() => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, isBioBased: true } })}
              />
              <div
                className={styles.checkbox}
                onClick={() => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, isBioBased: true } })}
              ></div>
              <label htmlFor="bioBased-yes">Yes</label>
              <input
                ref={biBasedNoRef}
                type="radio"
                name="bioBased"
                id="bioBased-no"
                value="false"
                checked={wizardFormData.adData.isBioBased == false}
                onChange={() => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, isBioBased: false } })}
              />
              <div
                className={styles.checkbox}
                onClick={() => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, isBioBased: false } })}
              ></div>
              <label htmlFor="bioBased-no">No</label>
            </div>
          </div>
        </div>
        <div className={styles.input_container}>          
          <label htmlFor="casNumber">CAS number</label>
          <InfoPopup content="Add the CAS number(s) connected to the product." />
          <input
            type="text"
            name="casNumber"
            id="casNumber"
            value={wizardFormData.adData.casNumber}
            onChange={(e) => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, casNumber: e.target.value } })}
            placeholder="Enter the CAS number for your alternative"
          />
        </div>

        <div className={`${styles.input_container} ${styles.files}`}>          <span>
          <b>Documents</b>
        </span>
          <InfoPopup content="For example an MSDS, third party verification or some other technical information." />
          {wizardFormData.editMode && wizardFormData.adData.technicalDataSheet ?
            <div>
              <span className={styles.document_type}>Technical data sheet: </span>
              <span className={styles.existing_file}>{wizardFormData.adData.technicalDataSheet?.fileName}
                <button type="button" onClick={() => removeExistingFile("", "technical")}>{closeIcon}</button>
              </span>
            </div>
            : ""
          }
          {wizardFormData.editMode && wizardFormData.adData.safetyDataSheet ?
            <div>
              <span className={styles.document_type}>Safety data sheet: </span>
              <span className={styles.existing_file}>{wizardFormData.adData.safetyDataSheet?.fileName}
                <button type="button" onClick={() => removeExistingFile("", "safety")}>{closeIcon}</button>
              </span>
            </div>
            : ""
          }
          {wizardFormData.editMode && wizardFormData.adData.additionalDocuments != null && wizardFormData.adData.additionalDocuments?.length > 0 ?
            <div>
              <span className={styles.document_type}>Additional documents: </span>
              {wizardFormData.adData.additionalDocuments?.map((document, index) => (
                <span key={index} className={styles.existing_file}>{document?.fileName}
                  <button type="button" onClick={() => removeExistingFile(document.fileName, "additional")}>{closeIcon}</button>
                </span>
              ))}
            </div>
            :
            ""
          }
          <div className={styles.upload_containers}>
            <label htmlFor="technicalDocument">Tecnical Data Sheet</label>
            <input
              ref={technicalDocumentRef}
              type="file"
              name="technicalDocument"
              id="technicalDocument"
              accept=".docx, .xls, .csv, .pdf"
              onChange={() => updateTechnicalDocumentText()}
            />
            <div className={styles.upload_container}>
              <i>{chooseDocumentIcon}</i>
              <button className={disableTechnical ? styles.disabled : ""} disabled={disableTechnical ? true : false} type="button" onClick={() => technicalDocumentRef.current?.click()}>
                {technicalDocumentText}
              </button>
            </div>
            <label htmlFor="safetyDocument">Safety Data Sheet</label>
            <input
              ref={safetydataRef}
              type="file"
              name="safetyDocument"
              id="safetyDocument"
              accept=".docx, .xls, .csv, .pdf"
              onChange={() => updateSafetydataText()}
            />

            <div className={styles.upload_container}>
              <i>{chooseDocumentIcon}</i>
              <button className={disableSafety ? styles.disabled : ""} disabled={disableSafety ? true : false} type="button" onClick={() => safetydataRef.current?.click()}>
                {safetydataText}
              </button>
            </div>
            <AdditionalDocuments uploadedFiles={uploadedFiles} onFileUpload={handleFileUpload} />
            {uploadedFiles.map((_, index) => (
              <AdditionalDocuments key={index} uploadedFiles={uploadedFiles} onFileUpload={handleFileUpload} />
            ))}
          </div>
          <span>Allowed document formats: DOCX, XLS, CSV or PDF</span>
        </div>

        <div className={styles.input_container}>          
          <label htmlFor="additionalInformation">Additional information</label>
          <InfoPopup content="This box is where you write the details of your product, what it can achieve and where it may be applied. There are no limitations, but try to be concise and to the point." />
          <textarea
            rows={10}
            name="additionalInformation"
            id="additionalInformation"
            placeholder="Is there any additional information you would like to include in your ad?"
            value={wizardFormData.adData.additionalInformation}
            onChange={(e) => setWizardFormData({ ...wizardFormData, adData: { ...wizardFormData.adData, additionalInformation: e.target.value } })}
          />
        </div>
      </div>
      <div className={styles.buttons}>
        {backButton("Contact information")}
        <button
          type="button"
          className="button button_black"
          onClick={() => nextStep()}
        >
          Next: Review your ad and submit
          {arrow_right}
        </button>
      </div>
    </div>
  );
}
